var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.852,
    height: 16.004,
    viewBox: "0 0 16.852 16.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-4.989 -6.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8501",
    "data-name": "Caminho 8501",
    d: "M18.472,15.267a3.369,3.369,0,0,0-2.8,1.5L11.539,14.7a3.369,3.369,0,0,0,.194-1.116,3.319,3.319,0,0,0-.126-.9l3.946-1.63A3.369,3.369,0,1,0,15.1,9.371a3.319,3.319,0,0,0,.126.9L11.282,11.9a3.369,3.369,0,1,0-.118,3.542L15.3,17.508a3.369,3.369,0,1,0,3.176-2.241Zm0-8.424a2.527,2.527,0,1,1-2.527,2.527,2.527,2.527,0,0,1,2.527-2.527ZM8.363,16.11a2.527,2.527,0,1,1,2.527-2.527A2.527,2.527,0,0,1,8.363,16.11Zm10.108,5.054A2.527,2.527,0,1,1,21,18.637,2.527,2.527,0,0,1,18.472,21.164Z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.e22d82267a2f6df0b05d5783cc41c0db.svg";
export { ForwardRef as ReactComponent };